import type { Template } from '../notion-sync/interface'
import { useEffect, useState } from 'react'

export const useTemplates = (): {
  loading: boolean
  templates: Template[]
} => {
  const [templates, setTemplates] = useState<Template[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let isMounted = true
    import('../notion-sync/templates').then((mod) => {
      if (isMounted) {
        setTemplates(mod.templates)
        setLoading(false)
      }
    })
    return () => {
      isMounted = false
    }
  }, [])

  return {
    loading,
    templates,
  }
}
